(function ($) {
  Drupal.behaviors.renutrivBrandStylesV1 = {
    attached: false,
    attach: function () {
      if (this.attached) {
        return;
      }
      this.attached = true;

      $('body').addClass('brand-style-renutriv');
    }
  };
})(jQuery);
